module.exports = __webpack_public_path__ + "static/media/21.daf44b84.jpg";